<custom-modal-card
  *ngIf="{
    banners: banners$ | async,
    bannerLoadError: bannerLoadError$ | async,
    canSaveSelectedBanner: canSaveSelectedBanner$ | async,
    canUserInteract: canUserInteract$ | async,
    isSavingBanner: isSavingBanner$ | async,
    isLoadingBanner: isLoadingBanner$ | async
  } as STATE"
  [enableFooter]="!!STATE.banners && !STATE.bannerLoadError"
  [disableClose]="!STATE.canUserInteract"
  class="program-banner-editor mat-dialog-transparent"
>
  <ng-container header>
    <h1>{{ title }}</h1>
    <p>Ajoutez/modifiez les bannières affichées sur la page du programme</p>
  </ng-container>
  <ng-container body>
    <section
      *ngIf="!STATE.isLoadingBanner && !STATE.bannerLoadError"
      class="mat-dialog-file-upload__content"
    >
      <banner-selector></banner-selector>
      <edit-banner-form [program]="program"></edit-banner-form>
    </section>

    <loading-or-error
      *ngIf="STATE.isLoadingBanner || STATE.bannerLoadError"
      [useIconOnly]="false"
      [error$]="bannerLoadError$"
      (retry)="loadBanners()"
    ></loading-or-error>
    <!-- <section
      *ngIf="STATE.banners && !STATE.bannerLoadError"
      class="mat-dialog-file-upload__content"
    >
      <banner-selector></banner-selector>
      <edit-banner-form [program]="program"></edit-banner-form>
    </section> -->
    <!-- <loading-or-error
      *ngIf="!STATE.banners || STATE.bannerLoadError"
      [useIconOnly]="false"
      (retry)="loadBanners()"
    ></loading-or-error> -->
  </ng-container>
  <ng-container footer>
    <button
      (click)="saveBanner()"
      [attr.loading]="STATE.isSavingBanner"
      [disabled]="!STATE.canSaveSelectedBanner || !STATE.canUserInteract"
      class="btn btn--primary"
    >
      Enregistrer la bannière
    </button>
  </ng-container>
</custom-modal-card>
